import { useEffect, useState } from 'react';
import { auth, db } from '../lib/firebase';
import { doc, onSnapshot } from 'firebase/firestore';

export interface LiveWalletData {
  balance: number;
  escrowBalance: number;
  totalEarnings: number;
}

/**
 * Subscribe to the current user's wallet document and return live values.
 * Automatically cleans up when auth changes or the component unmounts.
 */
export function useLiveWallet() {
  const [wallet, setWallet] = useState<LiveWalletData | null>(null);
  const [uid, setUid] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubAuth = auth.onAuthStateChanged((user) => {
      setUid(user?.uid || null);
      if (!user) {
        setWallet(null);
        return;
      }
      const unsubWallet = onSnapshot(doc(db, 'wallets', user.uid), (snap) => {
        setLoading(false);
        if (!snap.exists()) {
          setWallet({ balance: 0, escrowBalance: 0, totalEarnings: 0 });
          return;
        }
        const data = snap.data() as any;
        setWallet({
          balance: Number(data.balance || 0),
          escrowBalance: Number(data.escrowBalance || 0),
          totalEarnings: Number(data.totalEarnings || 0),
        });
      });
      return () => unsubWallet();
    });
    return () => unsubAuth();
  }, []);

  return { uid, wallet, loading } as const;
}